module.exports = __webpack_public_path__ + "static/media/card-back.ad714e27.svg";